import { defineComponent as _defineComponent } from 'vue'

const __default__ = {
  name: 'CategoryNavItem',
};

import { ref, computed } from '@nuxtjs/composition-api';
import CategoryNavItem from '@/components/category/CategoryNavItem.vue';
import { Breadcrumb, Category } from '@/types/category';

interface Props {
  country?: string | null;
  item?: Category | Record<string, never>;
  breadcrumbs?: Breadcrumb[];
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    country: { default: null },
    item: { default: () => ({}) as Category },
    breadcrumbs: { default: () => [] }
  },
  setup(__props: any) {

const props = __props as { country: string | null, item: Category | Record<string, never>, breadcrumbs: Breadcrumb[] };

/* Category Nav Item
 *
 * @parent: CategoryNav
 * @requests:
 * @events:
 * @props: Array items
 * @components: CategoryNavItem
 * @methods: toggleIsOpen
 */

// Recursively list sub-items


const sortedItems = computed(() => {
  if (
    props.item.items &&
    props.item.items.length > 0 &&
    props.item.items[0].items &&
    props.item.items[0].items.length > 0
  ) {
    return props.item.items;
  } else {
    if (props.breadcrumbs && props.breadcrumbs[1] && props.breadcrumbs[1].slug !== 'science-teks') {
      return props.item.items;
    }
    return [...(props.item.items ?? [])].sort(sortByName);
  }
});
const isOpen = ref<boolean>(false);

const toggleIsOpen = (open?: boolean): void => {
  isOpen.value = open || !isOpen.value;
};

const shouldOpen = (item: Category | Record<string, never>): boolean => {
  // Whether an item should be toggled open
  return props.breadcrumbs.some(b => item.link === b.link);
};

isOpen.value = shouldOpen(props.item as Category);
function sortByName(a: { name: string }, b: { name: string }) {
  // Split like ["S","1","10","A"]
  const partsA = a.name.split('.');
  const partsB = b.name.split('.');

  for (let i = 0; i < Math.max(partsA.length, partsB.length); i++) {
    const partA = partsA[i] || '';
    const partB = partsB[i] || '';

    // Compare numerically if both parts are numbers
    if (!Number.isNaN(Number(partA)) && !Number.isNaN(Number(partB))) {
      const numA = Number.parseInt(partA, 10);
      const numB = Number.parseInt(partB, 10);
      if (numA !== numB) {
        return numA - numB;
      }
    }

    // Otherwise compare as strings
    if (partA !== partB) {
      return partA.localeCompare(partB);
    }
  }
  return 0;
}

return { __sfc: true,props, sortedItems, isOpen, toggleIsOpen, shouldOpen, sortByName, CategoryNavItem }
}

})